import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import LoanType from './LoanType'
import LoanTypes from './LoanTypes'
import CreateInstallmentLoanType from './CreateInstallmentLoanType'
import CreateLineOfCreditLoanType from './CreateLineOfCreditLoanType'

const LoanTypesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <LoanTypes />
      </Route>

      <Route path={`${path}/create-installment-loan-type`}>
        <CreateInstallmentLoanType />
      </Route>

      <Route path={`${path}/create-line-of-credit-loan-type`}>
        <CreateLineOfCreditLoanType />
      </Route>

      <Route path={`${path}/:loanTypeId`}>
        <LoanType />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default LoanTypesRoutes
